module.exports = __webpack_public_path__ + "static/fonts/SCDream3.8be5836.otf";